/**
 * PageHeader · Mar 1, 2026
 * Unified page-header primitive per the Design Standard.
 *
 *   ┌──────────────────────────────────────────────────────────────┐
 *   │  Overline · Icon                                             │
 *   │  Title (H1)                          [ + Action ] [ Action ] │
 *   │  Subtitle / description                                      │
 *   └──────────────────────────────────────────────────────────────┘
 *
 * All primary action buttons live TOP-RIGHT. Use `<button class="btn-primary">`
 * for Add / Create actions (global blue) and `<button class="btn-danger">`
 * for Delete actions (outline red).
 */
import React from "react";

export default function PageHeader({ overline, title, subtitle, actions, testId }) {
  return (
    <div className="flex items-end justify-between gap-4 mb-4" data-testid={testId || "page-header"}>
      <div>
        {overline && <div className="overline mb-1 flex items-center gap-2">{overline}</div>}
        <h1 className="font-display text-3xl font-black tracking-tight text-white">{title}</h1>
        {subtitle && <div className="text-xs text-zinc-500 mt-1">{subtitle}</div>}
      </div>
      {actions && <div className="flex items-center gap-2 flex-wrap justify-end" data-testid="page-header-actions">{actions}</div>}
    </div>
  );
}
